import { Trans } from 'react-i18next';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../translations';

import { useGifDecisions } from './GifDecisionsCard.hooks';
import {
   StyledGifDecisionsCard,
   StyledGifDecisionsCardHeader,
   StyledGifDecisionsList,
   StyledHeading,
} from './GifDecisionsCard.styled';
import { GifDecisionsCardListElement } from './GifDecisionsCardListElement';
import { GifDecisionsCardListElementLoader } from './GifDecisionsCardListElement.loader';
import { StyledCardUpdatedData } from './shared/Card.styled';
import { DateUpdatedText } from './shared/DateUpdatedText';

export const GifDecisionsCard = (): JSX.Element => {
   const { gifDecisions, gifDecisionsLoading, gifDecisionsError } = useGifDecisions();

   return (
      <StyledGifDecisionsCard {...appendTestableElementAttributes('gifDecisions')}>
         <StyledGifDecisionsCardHeader justifyContent='space-between' gap={'6px'}>
            <StyledHeading
               bold
               content={dashboardTranslationKeys.cards.gifDecisions}
               testId={'gifDecisions'}
               type='h2'
               margin={'8px'}
            />
            {gifDecisions && gifDecisions.length > 0 ? (
               <StyledCardUpdatedData {...appendTestableElementAttributes('dataUpdated')}>
                  <Trans
                     i18nKey={dashboardTranslationKeys.cards.dataUpdated}
                     components={{
                        date: <DateUpdatedText date={new Date(gifDecisions[0].importDate)} />,
                     }}
                  />
               </StyledCardUpdatedData>
            ) : null}
         </StyledGifDecisionsCardHeader>
         <StyledGifDecisionsList {...appendTestableElementAttributes('gifDecisionsList')}>
            <GifDecisionsCardListElementLoader
               gifDecisions={gifDecisions}
               gifDecisionsLoading={gifDecisionsLoading}
               gifDecisionsError={gifDecisionsError}
            >
               {({ gifDecisions }) => (
                  <>
                     {gifDecisions.map((decision) => (
                        <GifDecisionsCardListElement gifDecision={decision} key={decision.viewLink} />
                     ))}
                  </>
               )}
            </GifDecisionsCardListElementLoader>
         </StyledGifDecisionsList>
      </StyledGifDecisionsCard>
   );
};
